import { User } from '@supabase/supabase-js';

export interface RequireUserOptions {
  user: User | null;
  navigate: (path: string) => void;
  currentPath: string;
  action?: () => void;
}

/**
 * Gate an action behind login. Redirects to /auth with returnTo if not logged in.
 */
export function requireUser({ user, navigate, currentPath, action }: RequireUserOptions) {
  if (!user) {
    const returnTo = encodeURIComponent(currentPath + window.location.search);
    navigate(`/auth?returnTo=${returnTo}`);
    return;
  }

  if (action) {
    action();
  }
}
